export enum EnumExpInsumos {
  FMultiplicar = 'Multiplicar',
  FDividir = 'Dividir',
  FMoneda1 = 'Moneda1',
  FMoneda2 = 'Moneda2',
  MTodos = 'Todos',
  MSoloExplosion = 'SoloExplosion',
  MConceptosPresupuesto = 'ConceptosPresupuesto',
  MBasicos = 'Basicos',
  MSoloMarcados = 'SoloMarcados'
}

export enum EnumTipoExpIns {
  DeTodoElPresupuesto = 0,
  SoloLasMarcadas = 1,
  NoCalcular = 2
}

export enum EnumIncovarExpIns {
  DesdeExpIns = 0,
  DesdePpto = 1,
  DesdeMatriz = 2,
}

export enum EnumPartidaMatrizActiva {
  Conceptos = 0,
  Matriz = 1
}

export enum EnumAplicarExpresion {
  Presupuesto = 0,
  Matriz = 1,
  PptoCompleto = 2,
  Conceptos = 3
}
export enum EnumRenumerarRenglon {
  Presupuesto = 0,
  PptoCompleto = 1,
}
